export default __webpack_public_path__ + "static/media/howItWorksClient1.ee05bfda.png";